module.exports = __webpack_public_path__ + "img/mch-main-zy.b5977c06.png";